import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'error'
})
export class ErrorPipe implements PipeTransform {
  static extractMessageFromError(error: any) {
    let message = error;

    if (typeof error !== 'string') {
      if (typeof message.error === "string" && message.error.indexOf("html>") === -1) {
        message = message.error;
      }
      else {
        message = message.message;
      }
    }

    if (typeof message === "object") {
      message = JSON.stringify(message);
    }

    return message;
  }

  transform(error: any): any {
    return ErrorPipe.extractMessageFromError(error);
  }
}
